package app.bloomey.web.core.data

import kotlinx.browser.localStorage
import org.w3c.dom.get
import org.w3c.dom.set

object SessionManager {

    val signedIn: Boolean
        get() = authToken.isNotEmpty()

    val authToken: String
        get() = localStorage["token"] ?: ""

    fun startSession(token: String) {
        localStorage["token"] = token
    }

    fun endSession() {
        localStorage.removeItem("token")
    }
}